import React from 'react'

import { Form, Col } from '_zari/core'

const PorcentajeFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='PORC %' htmlFor='input-Porcentaje' md={4} />
      <Col md={8}>
        <Form.InputNumber id='input-Porcentaje' name='input-Porcentaje' value={value} onChange={onChange} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(PorcentajeFormGroup)
